module.exports = __webpack_public_path__ + "/login_ui/img/ie-2cb766a2828e9cf4e2f7b540cd4dd589.svg";